import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
export var IconSystemMug = function IconSystemMug(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 2,
    d: "M8.5 8.5h-3a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h3m4 5h4a4 4 0 0 0 4-4v-12a1 1 0 0 0-1-1h-10a1 1 0 0 0-1 1v12a4 4 0 0 0 4 4Z"
  }));
};